<template>
  <div id="app">
    <dayLocation />
  </div>
</template>

<script>
import dayLocation from "./components/dayLocation";

export default {
  name: "App",
  components: {
    dayLocation
  }
};
</script>

<style>
* {
  padding: 0;
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue